import React from 'react';
import { createTheme } from '@mui/material';
import { customTypography } from './customTypography';
import { ColorPalette, TypographyFamily, BorderRadius } from '../constants';

export const customComponents = createTheme({
  ...customTypography,

  components: {
    MuiAutocomplete: {
      defaultProps: {
        renderOption: (props, option, state, ownerState) => (
          <li
            {...props}
            className={[
              state.selected
                ? 'dropdown-list-item-selected'
                : 'dropdown-list-item',
              props.className,
            ].join(' ')}
            style={{
              color: ColorPalette.RAISIN_BLACK,
              padding: '6px 16px',
              cursor: 'pointer',
            }}
          >
            {ownerState.getOptionLabel(option)}
          </li>
        ),
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          fontSize: '16px',
          textTransform: 'none',
        },

        contained: {
          boxShadow: 'none',
          borderRadius: BorderRadius.HUGE,
          backgroundColor: 'transparent',
          border: `2px solid ${ColorPalette.DARK_GRAY}`,
          fontFamily: TypographyFamily.ARIAL,
          color: ColorPalette.RAISIN_BLACK,

          '&:hover': {
            boxShadow: 'none',
            color: ColorPalette.WHITE,
          },

          ':disabled': {
            border: 'none',
            backgroundColor: ColorPalette.MIDDLE_BLUE,
            color: ColorPalette.RAISIN_BLACK,
          },
        },
      },
    },

    MuiAccordionActions: {
      styleOverrides: {
        root: {
          '& :not(:first-of-type)': {
            marginLeft: '0px',
          },
        },
      },
    },

    MuiDialogActions: {
      styleOverrides: {
        root: {
          padding: '0px',
          '& :not(:first-of-type)': {
            marginLeft: '0px',
          },
        },
      },
    },

    MuiPaper: {
      styleOverrides: {
        root: {
          boxShadow: '0px 0px 4px 0px rgba(0, 0, 0, 0.10)',
          borderRadius: BorderRadius.SMALL,
          '&::before': {
            backgroundColor: 'rgba(0, 0, 0, 0)',
          },
        },
      },
    },

    MuiCardActions: {
      styleOverrides: {
        root: {
          '&&>:not(first-of-type)': {
            marginLeft: '0px',
          },
        },
      },
    },

    MuiFilledInput: {
      styleOverrides: {
        root: {
          background: ColorPalette.LIGHT_GRAY,
          borderRadius: BorderRadius.SMALL,
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: ColorPalette.DARK_GRAY,
          fontWeight: 700,
          fontFamily: TypographyFamily.ARIAL,

          '&.MuiInputLabel-shrink': {
            background: ColorPalette.DARK_GRAY,
            backgroundClip: 'text',
            textFillColor: 'transparent',
            fontSize: '16px',
            lineHeight: '21px',
            fontWeight: 700,
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            '&.Mui-focused': {
              background: ColorPalette.GRADIENT_TWO,
              backgroundClip: 'text',
              textFillColor: 'transparent',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
            },
          },

          '&.Mui-focused': {
            '&.Mui-error': {
              background: ColorPalette.WARNING_RED,
              backgroundClip: 'text',
              textFillColor: 'transparent',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
            },
          },
        },
      },
    },

    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: BorderRadius.SMALL,

          '&:Mui-error': {
            color: ColorPalette.WARNING_RED,
          },
        },

        notchedOutline: {
          borderColor: ColorPalette.DARK_GRAY,
        },
      },
    },
  },
});
